import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import PageNotFound from '@/pages/PageNotFound';
import { RedirectWithSearchParams } from '@/components/RedirectWithSearchParams';

import { EmbeddedPageWrapper } from './EmbeddedPageWrapper';
import { ErrorPage } from './ErrorPage';

const EmbeddedStorefrontPage = lazy(
  () => import('@/pages/Embedded/Storefront/EmbeddedStorefrontPage')
);

const EmbeddedShipLaptopPage = lazy(
  () => import('@/pages/Embedded/Shipments/EmbeddedShipLaptopPage')
);

/**
 * Embedded Routes
 *
 * Routes under /embed/* that are meant to be embedded in iframes.
 * EmbedBlocker handles iframe validation.
 */
export const EmbeddedRoutes = () => {
  const { ithEmbeddedRoutes } = useFlags();

  // Base route is /embed/...
  return (
    <Routes>
      <Route element={<EmbeddedPageWrapper />} errorElement={<ErrorPage />}>
        {ithEmbeddedRoutes ? (
          <>
            <Route
              path="/purchase-hardware" // For backwards compatibility
              element={<RedirectWithSearchParams to="/embed/get-hardware" />}
            />
            <Route path="/get-hardware" element={<EmbeddedStorefrontPage />} />
            <Route path="/ship-laptop" element={<EmbeddedShipLaptopPage />} />
          </>
        ) : (
          <Route path="*" element={<PageNotFound />} />
        )}
      </Route>
    </Routes>
  );
};
